import {
  AdServer,
  AdServerInit,
  AdServerUpdate,
  DeletedAdServer,
  ListResult,
  SearchableFilter,
} from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import type { RequestOptions } from 'common/network/request-options'
import { AdServersRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export class AdServersApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listAdServers(
    { filter, name, ...params }: AdServersRequestParams,
    options?: Pick<RequestOptions, 'signal'>,
  ): Promise<ListResult<AdServer>> {
    const searchFilter: any = {}

    if (name) {
      searchFilter.searchName = name
    }

    if (filter) {
      searchFilter.searchAny = filter
    }

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter: searchFilter,
      paginatedRequestParams: params,
    })

    return this.edgeClient.listExternalAdServers(query, options)
  }

  getAdServer(id: string): Promise<AdServer> {
    return this.edgeClient.getExternalAdServer(id)
  }

  createAdServer(adServer: AdServerInit): Promise<AdServer> {
    return this.edgeClient.createExternalAdServer(adServer)
  }

  updateAdServer(id: string, adServer: AdServerUpdate): Promise<AdServer> {
    return this.edgeClient.updateExternalAdServer(id, adServer)
  }

  deleteAdServer(id: string): Promise<DeletedAdServer> {
    return this.edgeClient.deleteExternalAdServer(id)
  }
}
